import { useOcppTagHistory } from '@services/ocpp'
import useLocationSearch from '@shared/innmaxLib/hooks/useLocationSearch'
import useSearch from '@shared/innmaxLib/hooks/useSearch'
import { rules } from '@shared/innmaxLib/utils/form'
import { momentToString } from '@shared/innmaxLib/utils/webHelper'
import { Flex } from '@shared/innmaxUI'
import { Input } from '@shared/innmaxUI/Form'
import Table from '@shared/Table'
import { Form, Space } from 'antd'
import { ColumnsType } from 'antd/lib/table'
import { useTranslation } from 'react-i18next'
import Button from 'src/components/Button'
import { FormItem } from 'src/components/Form'

function EvccidList() {
  const { t } = useTranslation()

  const [form] = Form.useForm()

  const queryParams = useLocationSearch()

  const { handleSearch, query } = useSearch({
    form,
    keepPreviousQuery: false,
  })

  const { data, isLoading, refetch } = useOcppTagHistory(query, {
    enabled: !!query?.deviceId,
  })

  const columns: ColumnsType<any> = [
    {
      title: 'EVCC ID',
      dataIndex: 'tagId',
    },
    {
      title: '建立時間',
      dataIndex: 'createdAt',
      render: momentToString,
    },
  ]

  return (
    <>
      <div className="bg-[#272727] min-h-[100dvh] py-[1rem] px-[2rem]">
        <h1 className="text-3xl text-white">EVCCID 列表</h1>
        <Form layout="inline" form={form}>
          <FormItem
            rules={[rules.required]}
            name="deviceId"
            label="充電樁設備編號"
            className="w-264">
            <Input allowClear placeholder="輸入充電樁設備編號" />
          </FormItem>

          <FormItem.Button>
            <Button.Search onClick={handleSearch} />
          </FormItem.Button>
        </Form>
        <div className="mt-44 mb-16">
          <Flex between>
            <Space>
              <Table.RowCount count={data?.length || 0} />
            </Space>
          </Flex>
        </div>
        <Table
          className="w-full"
          dataSource={{
            content: data || [],
            total: data?.length || 0,
            totalPages: 1,
          }}
          loading={isLoading}
          columns={columns}
          pagination={false}
          rowKey={'tagId'}
        />
      </div>
    </>
  )
}

export default EvccidList
